export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-rocket-2-line',
      title: 'Product Discovery',
      desc: 'Find trending products and curated collections updated regularly through Basetao Spreadsheet resources, saving you hours of manual browsing.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Verified Resources',
      desc: 'All Basetao Spreadsheet information is independently verified and updated for 2026 to ensure accuracy and reliability for international shoppers.',
    },
    {
      icon: 'ri-guide-line',
      title: 'Shopping Guides',
      desc: 'Step-by-step Basetao Spreadsheet tutorials and buying guides designed for both beginners and experienced international shoppers.',
    },
    {
      icon: 'ri-global-line',
      title: 'International Focus',
      desc: 'Resources tailored for global buyers, covering shipping methods, customs considerations, and cross-border shopping tips for Basetao Spreadsheet users.',
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Deals & Discounts',
      desc: 'Stay updated with the latest Basetao coupon codes, discount strategies, and money-saving tips to maximize your shopping budget.',
    },
    {
      icon: 'ri-article-line',
      title: 'Expert Content',
      desc: 'Original, well-researched Basetao Spreadsheet articles and reviews written by experienced shoppers who understand international e-commerce.',
    },
  ];

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-6 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 mb-4 text-xs font-medium tracking-wider uppercase rounded-full bg-primary-100 text-primary-700">
            Why Choose Us
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            Why People Use Basetao Spreadsheet
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Thousands of international shoppers rely on Basetao Spreadsheet resources every day. Here is what makes our platform unique.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feat, idx) => (
            <div
              key={idx}
              className="group p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-300"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-4 group-hover:scale-110 transition-transform duration-300">
                <i className={`${feat.icon} text-xl`}></i>
              </span>
              <h3 className="font-label font-semibold text-foreground-900 text-sm mb-2">{feat.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}